import { render, staticRenderFns } from "./Inspeccion_Lista.vue?vue&type=template&id=366c9952&"
import script from "./Inspeccion_Lista.vue?vue&type=script&lang=js&"
export * from "./Inspeccion_Lista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports